// export const sitemap = (obj) => {
// 	document.title = language("NAV_SITEMAP");
//     return `${obj.content}`;
// 	return `
//         <section class="breadcrumbs">
//           <div class="container">
//             <div class="row">
//                 <div class="col-sm-12">
//                     <div class="fullnav__breadcrumb__container">
//                         <nav aria-label="breadcrumb">
//                             <ol class="aim-breadcrumb fullnav__breadcrumb" id="full__breadcrumb">
//                             <li class="aim-breadcrumb-item"><a href="/">${language(
// 															"NAV_FRONTPAGE",
// 														)}</a></li>
//                             <li class="aim-breadcrumb-item active" aria-current="page" id="currentPageBreadcrumb">${language(
// 															"NAV_SITEMAP",
// 														)}</li>
//                             </ol>
//                         </nav>
//                     </div>
//                 </div>
//             </div>
//         </section>
//         <section class="sitemap__section">
//             <div class="container">
//                 <div class="row ">
//                     <div class="col-md-12">
//                         <div class="sitemap__content">
//                             <h1 class="page__header">${language("NAV_SITEMAP")}</h1>
//                             ${obj.content}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </section>
//     `;
// };
export const category = (obj) => {
	return `
        <div class="sitemap__category level-${obj.level}">
            <a href="/nav/${obj.item.full_url}">${obj.item.previewItem}</a>
        </div>
    `;
};
export const article = (obj) => {
	return `
        <div class="sitemap__article level-${obj.level}">
            <a href="/artikkel/${obj.item.contentId}">${obj.item.title}</a>
        </div>
    `;
};
